export interface AvatarColor {
  /** Stored in DB, e.g. "blue" */
  name: string;
  /** Display label, e.g. "Blue" */
  label: string;
  /** Tailwind class name */
  className: string;
}

export const AVATAR_COLORS: AvatarColor[] = [
  { name: 'red', label: 'Red', className: 'text-red-600 bg-red-100 dark:bg-red-500/50 dark:text-red-50' },
  {
    name: 'orange',
    label: 'Orange',
    className: 'text-orange-600 bg-orange-100 dark:bg-orange-500/50 dark:text-orange-50',
  },
  {
    name: 'amber',
    label: 'Amber',
    className: 'text-amber-600 bg-amber-100 dark:bg-amber-500/50 dark:text-amber-50',
  },
  {
    name: 'yellow',
    label: 'Yellow',
    className: 'text-yellow-600 bg-yellow-100 dark:bg-yellow-500/50 dark:text-yellow-50',
  },
  { name: 'lime', label: 'Lime', className: 'text-lime-600 bg-lime-100 dark:bg-lime-500/50 dark:text-lime-50' },
  {
    name: 'green',
    label: 'Green',
    className: 'text-green-600 bg-green-100 dark:bg-green-500/50 dark:text-green-50',
  },
  {
    name: 'emerald',
    label: 'Emerald',
    className: 'text-emerald-600 bg-emerald-100 dark:bg-emerald-500/50 dark:text-emerald-50',
  },
  { name: 'teal', label: 'Teal', className: 'text-teal-600 bg-teal-100 dark:bg-teal-500/50 dark:text-teal-50' },
  { name: 'cyan', label: 'Cyan', className: 'text-cyan-600 bg-cyan-100 dark:bg-cyan-500/50 dark:text-cyan-50' },
  { name: 'sky', label: 'Sky', className: 'text-sky-600 bg-sky-100 dark:bg-sky-500/50 dark:text-sky-50' },
  { name: 'blue', label: 'Blue', className: 'text-blue-600 bg-blue-100 dark:bg-blue-500/50 dark:text-blue-50' },
  {
    name: 'indigo',
    label: 'Indigo',
    className: 'text-indigo-600 bg-indigo-100 dark:bg-indigo-500/50 dark:text-indigo-50',
  },
  {
    name: 'violet',
    label: 'Violet',
    className: 'text-violet-600 bg-violet-100 dark:bg-violet-500/50 dark:text-violet-50',
  },
  {
    name: 'purple',
    label: 'Purple',
    className: 'text-purple-600 bg-purple-100 dark:bg-purple-500/50 dark:text-purple-50',
  },
  {
    name: 'fuchsia',
    label: 'Fuchsia',
    className: 'text-fuchsia-600 bg-fuchsia-100 dark:bg-fuchsia-500/50 dark:text-fuchsia-50',
  },
  {
    name: 'pink',
    label: 'Pink',
    className: 'text-pink-600 bg-pink-100 dark:bg-pink-500/50 dark:text-pink-50',
  },
  { name: 'rose', label: 'Rose', className: 'text-rose-600 bg-rose-100 dark:bg-rose-500/50 dark:text-rose-50' },
];

/** Resolve a stored color name to its AvatarColor, or null if not found */
export function getAvatarColor(name: string | null | undefined): AvatarColor | null {
  if (!name) return null;
  return AVATAR_COLORS.find((c) => c.name === name) ?? null;
}

export function getAvatarFallbackClass(avatarColor: string | null | undefined): string {
  const resolved = avatarColor ? getAvatarColor(avatarColor) : null;
  return resolved ? resolved.className : 'text-accent-foreground bg-accent';
}
